import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'tx-technician-location',
  templateUrl: './technician-location.component.html',
  styleUrls: ['./technician-location.component.css']
})
export class TechnicianLocationComponent implements OnInit {
  _title: string;
  _date: any;
  _mapid: string;
  _coordinate: any;

  constructor() {
  }

  ngOnInit() {
  }

  @Input()
  set title(title) {
    this._title = title;
  }

  get title() {
    return this._title;
  }

  @Input()
  set date(date) {
    this._date = date;
  }

  get date() {
    return this._date;
  }

  @Input()
  set mapid(mapid) {
    this._mapid = mapid;
  }

  get mapid() {
    return this._mapid;
  }

  @Input()
  set coordinate(coordinate) {
    this._coordinate = coordinate;
  }

  get coordinate() {
    return this._coordinate;
  }

  showEmptyState() {
    return !this._coordinate || this._coordinate === null;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/component/technician-location/technician-location.component.ts